<template lang="pug">
  div
    b-row
      .col-xl-12
        panel(:title='$t("ui.search")')
          b-row(v-show="isValid")
            .col-sm-12.col-md-12.col-lg-8.col-xl-8
              panel(:title='$t("title.account_profile")' :bodyClass="'childBody'")
                b-row.flex
                  .col-sm-12.col-md-6.col-lg-6.col-xl-6.mb-2
                    label {{ $t("ui.account_id") }}
                    DebounceInput(
                      type="text"
                      ref="account_id"
                      :placeholder='$t("ui.account_id")'
                      v-model="account_id"
                      :disabled="loading"
                      size="sm"
                    )
                  .col-sm-12.col-md-6.col-lg-6.col-xl-6.mb-2
                    label {{ $t("ui.full_name") }}
                    DebounceInput(
                      type="text"
                      ref="full_name"
                      :placeholder='$t("ui.full_name")'
                      v-model="full_name"
                      :disabled="loading"
                    )
                  .col-sm-12.col-md-6.col-lg-6.col-xl-6.mb-2
                    label {{ $t("ui.contact_phone") }}
                    DebounceInput(
                      type="text"
                      ref="contact_phone"
                      v-model="contact_phone"
                      :disabled="loading"
                    )
                  //- .col-sm-12.col-md-6.col-lg-6.col-xl-6.mb-2(v-if="!(account_id.length > 8)")
                  //-   label {{ $t("ui.contact_email") }}
                  //-   DebounceInput(
                  //-     type="text"
                  //-     ref="contact_email"
                  //-     :placeholder='$t("ui.contact_email")'
                  //-     v-model="contact_email"
                  //-     :disabled="loading"
                  //-   )
                  .col-sm-12.col-md-6.col-lg-6.col-xl-6
                    MoneyInput(
                      ref="credit_limit"
                      :placeholder='$t("ui.credit_limit")'
                      v-model="credit_limit"
                      :disabled="loading"
                    )
                  .col-sm-12.col-md-6.col-lg-6.col-xl-6(v-if="!(account_id.length > 8)")
                    MoneyInput(
                      ref="member_credit_limit"
                      :placeholder='$t("ui.member_credit_limit")'
                      v-model="member_credit_limit"
                      :disabled="loading"
                    )
                  .col-sm-12.col-md-12.col-lg-12.col-xl-12.mb-2(v-if="!(account_id.length > 8)")
                    .textfield-box
                      label.mb-2 {{ $t('ui.payment_option') }}
                      b-form-checkbox-group(
                        ref="payment_option"
                        v-model="payment_option"
                        :disabled="loading"
                        :options="isDayEnabledList"
                      )
                b-row.flex
                  .col-sm-12.col-md-6.col-lg-6.col-xl-6.mb-2(v-if="account_id.length > 8")
                    label {{ $t("ui.win_limit") }}
                    DebounceInput(
                      type="number"
                      ref="win_limit"
                      :placeholder='$t("ui.win_limit")'
                      v-model="win_limit"
                      :disabled="loading"
                    )
                    small.text-muted.text-danger.mr-1 {{ $t("ui.win_limit_tooltips") }}
                    i.fa.fa-info-circle(aria-hidden="true" :title='$t("ui.win_limit_tooltips1")')
                  .col-sm-12.col-md-6.col-lg-6.col-xl-6.mb-2(v-if="account_id.length > 8")
                    .form-group
                      label.mb-2 {{ $t('ui.daily_reset') }}
                      br
                      label.switch.switch-label.switch-success
                        input(type="checkbox" class="switch-input" v-model="daily_reset" :disabled="loading")
                        span(class="switch-slider" :data-checked="$t('ui.on')" :data-unchecked="$t('ui.off')")
            .col-sm-12.col-md-12.col-lg-8.col-xl-8
              ul.nav.nav-pills.mb-2
                li.nav-item
                  a.nav-link.active(href="#nav-pt" data-toggle="tab")
                    span.d-sm-none {{ $t("ui.position_taking") }}
                    span.d-sm-block.d-none {{ $t("ui.position_taking") }}
                li.nav-item
                  a.nav-link(href="#nav-bl" data-toggle="tab")
                    span.d-sm-none {{ $t("ui.bet_limit") }}
                    span.d-sm-block.d-none {{ $t("ui.bet_limit") }}
                li.nav-item
                  a.nav-link(href="#nav-cm" data-toggle="tab")
                    span.d-sm-none {{ $t("ui.commission") }}
                    span.d-sm-block.d-none {{ $t("ui.commission") }}
              .tab-content.rounded.bg-white
                #nav-pt.tab-pane.fade.active.show
                  ptSettings(ref="ptSettings" :loading="loading" :accountID="account_id" :platformList="platformList")
                #nav-bl.tab-pane.fade
                  betLimitSettings(ref="betLimitSettings" :loading="loading" :accountID="account_id" :platformList="platformList")
                #nav-cm.tab-pane.fade
                  commSettings(ref="commSettings" :loading="loading" :accountID="account_id" :platformList="platformList")
</template>

<script>
import config from "@/config";
import SubmitButton from "@/library/SubmitButton";
import DebounceInput from "@/library/DebounceInput";
import MoneyInput from "@/library/MoneyInput2";

import ptSettings from "@/components/positionTakingSearch/ptSettings.vue";
import commSettings from "@/components/commissionSearch/commSettings.vue";
import betLimitSettings from "@/components/betLimitSearch/betLimitSettings.vue";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    MoneyInput,
    ptSettings,
    commSettings,
    betLimitSettings
  },
  data() {
    return {
      platformList: [],
      uplineID: "",
      account_id: "",
      full_name: "",
      // currency: this.$store.getters.getAccountCurrency,
      contact_phone: "",
      // contact_email: "",
      credit_limit: "0",
      member_credit_limit: "0",
      win_limit: 0,
      daily_reset: 0,
      payment_option: [],
      loading: true,
      isValid: false,
      submission: {
        success: true,
        status: ""
      }
    }
  },
  validations: {},
  computed: {
    isDayEnabledList() {
      return this.$helpers.isDayEnabledList();
    },
    search_id() {
      return this.$store.getters.getSelectedID;
    },
    currency() {
      return this.$store.getters.getAccountCurrency;
    }
  },
  watch: {
    search_id(val) {
      this.search()
    }
  },
  mounted: function() {
    let vm = this
    if(this.search_id != "") {
      this.search()
    } else {
      this.$router.push("/overview").catch(err=>{})
    }
    //browser back button clear selectedID
    // window.onpopstate = function(event) {
    //   // alert("location: " + document.location + ", state: " + JSON.stringify(event.state));
    //   vm.$store.dispatch("user/setSelectedID", vm.uplineID)
    //   console.log(vm.$store.getters.getSelectedID)
    // };
  },
  methods: {
    search: function() {
      this.$helpers.getSchedule()
      this.getAccountDetails()
    },
    getChildPlatform: function() {
      let account_id = this.search_id
      this.$store
        .dispatch("user/getPlatform", { account_id })
        .then(response => {
          if (response.success == true) {
            let child = response.data.platform
            let list = []
            if(child) {
              child.forEach(y => {
                list.push(y.platform_code);
              });
              this.platformList = [...new Set(list)];
            }
          }
        })
        .catch(response => {});
    },
    getChildBetLimit: function() {
      let account_id = this.search_id
      let path = this.$refs.betLimitSettings
      this.$store
        .dispatch("user/getChildBetLimit", { account_id })
        .then(response => {
          if(response.data.blSB.length > 0) {
            path.soccer_min_bet = this.$helpers.numberFormat(response.data.blSB[6].min_bet)
            path.soccer_max_bet = this.$helpers.numberFormat(response.data.blSB[6].max_bet)
            path.soccer_max_per_match = this.$helpers.numberFormat(response.data.blSB[6].max_per_match)

            path.basketball_min_bet = this.$helpers.numberFormat(response.data.blSB[1].min_bet)
            path.basketball_max_bet = this.$helpers.numberFormat(response.data.blSB[1].max_bet)
            path.basketball_max_per_match = this.$helpers.numberFormat(response.data.blSB[1].max_per_match)

            path.tennis_min_bet = this.$helpers.numberFormat(response.data.blSB[7].min_bet)
            path.tennis_max_bet = this.$helpers.numberFormat(response.data.blSB[7].max_bet)
            path.tennis_max_per_match = this.$helpers.numberFormat(response.data.blSB[7].max_per_match)

            path.baseball_min_bet = this.$helpers.numberFormat(response.data.blSB[0].min_bet)
            path.baseball_max_bet = this.$helpers.numberFormat(response.data.blSB[0].max_bet)
            path.baseball_max_per_match = this.$helpers.numberFormat(response.data.blSB[0].max_per_match)

            path.parlay_min_bet = this.$helpers.numberFormat(response.data.blSB[5].min_bet)
            path.parlay_max_bet = this.$helpers.numberFormat(response.data.blSB[5].max_bet)
            path.parlay_max_per_match = this.$helpers.numberFormat(response.data.blSB[5].max_per_match)

            path.esports_min_bet = this.$helpers.numberFormat(response.data.blSB[3].min_bet)
            path.esports_max_bet = this.$helpers.numberFormat(response.data.blSB[3].max_bet)
            path.esports_max_per_match = this.$helpers.numberFormat(response.data.blSB[3].max_per_match)

            path.others_min_bet = this.$helpers.numberFormat(response.data.blSB[4].min_bet)
            path.others_max_bet = this.$helpers.numberFormat(response.data.blSB[4].max_bet)
            path.others_max_per_match = this.$helpers.numberFormat(response.data.blSB[4].max_per_match)

            path.cs_min_bet = this.$helpers.numberFormat(response.data.blSB[2].min_bet)
            path.cs_max_bet = this.$helpers.numberFormat(response.data.blSB[2].max_bet)
            path.cs_max_per_match = this.$helpers.numberFormat(response.data.blSB[2].max_per_match)

            if (account_id.length > 8) {
              path.livecasino_bet_limit_packages = response.data.blLC[0].bet_limit_package
              path.lotto_bet_limit_packages = response.data.blLO[0].bet_limit_package
              path.keno_bet_limit_packages = response.data.blKN[0].bet_limit_package
              path.cockfight_bet_limit_packages = response.data.blCF[0].bet_limit_package
              path.lottery_bet_limit_packages = response.data.blLT[0].bet_limit_package
            } else {
              path.livecasino_bet_limit_packages = response.data.blLC[0].bet_limit_package.split(",")
              path.lotto_bet_limit_packages = response.data.blLO[0].bet_limit_package.split(",")
              path.keno_bet_limit_packages = response.data.blKN[0].bet_limit_package.split(",")
              path.cockfight_bet_limit_packages = response.data.blCF[0].bet_limit_package.split(",")
              path.lottery_bet_limit_packages = response.data.blLT[0].bet_limit_package.split(",")
            }
          }
      })
      .catch(response => {
        // console.log("child", response)
      });
    },
    getChildCommission: function() {
      let account_id = this.search_id
      this.$store
        .dispatch("user/getChildCommission", { account_id })
        .then(response => {
          let path = this.$refs.commSettings
          if(response.data.cmSB.length > 0) {
            if(!(this.account_id.length > 8)) {
              path.comm_sportsbook_hdp_packages = this.$store.getters.getCommSBPackages
              path.comm_sportsbook_hdp_a = response.data.cmSB[0].hdp_a
              path.comm_sportsbook_hdp_b = response.data.cmSB[0].hdp_b
              path.comm_sportsbook_hdp_c = response.data.cmSB[0].hdp_c
              path.comm_sportsbook_hdp_d = response.data.cmSB[0].hdp_d
              path.comm_sportsbook_hdp_e = response.data.cmSB[0].hdp_e
              path.comm_sportsbook_hdp_f = response.data.cmSB[0].hdp_f

              path.comm_sportsbook_hdp_i = response.data.cmSB[0].hdp_i
              path.comm_sportsbook_hdp_j = response.data.cmSB[0].hdp_j
            } else {
              path.comm_sportsbook_hdp_packages = response.data.cmSB[0].hdp_packages
              switch(response.data.cmSB[0].hdp_packages){
                case "A":
                  path.comm_sportsbook_hdp_a = response.data.cmSB[0].hdp_a
                  break
                case "B":
                  path.comm_sportsbook_hdp_b = response.data.cmSB[0].hdp_b
                  break
                case "C":
                  path.comm_sportsbook_hdp_c = response.data.cmSB[0].hdp_c
                  break
                case "D":
                  path.comm_sportsbook_hdp_d = response.data.cmSB[0].hdp_d
                  break
                case "E":
                  path.comm_sportsbook_hdp_e = response.data.cmSB[0].hdp_e
                  break
                case "F":
                  path.comm_sportsbook_hdp_f = response.data.cmSB[0].hdp_f
                  break
                case "I":
                  path.comm_sportsbook_hdp_i = response.data.cmSB[0].hdp_i
                  break
                case "J":
                  path.comm_sportsbook_hdp_j = response.data.cmSB[0].hdp_j
                  break
              }
            }
            path.comm_sportsbook_1x2 = response.data.cmSB[0].one_x_two
            path.comm_sportsbook_others = response.data.cmSB[0].others

            if(['MMK','MMO'].includes(this.currency)) {
              path.comm_hdp_mmo = response.data.cmMMO[0].hdp
              path.comm_parlay_mmo_a = response.data.cmMMO[0].parlay_a
              path.comm_parlay_mmo_b = response.data.cmMMO[0].parlay_b
            }

            path.comm_casino = response.data.cmLC[0].account_commission
            path.comm_slots = response.data.cmSL[0].account_commission

            path.comm_lotto = response.data.cmLO[0].account_commission
            path.comm_keno = response.data.cmKN[0].account_commission
            path.comm_cockfight = response.data.cmCF[0].account_commission
            path.comm_lottery_1d = response.data.cmLT[0].one_d
            path.comm_lottery_2d = response.data.cmLT[0].two_d
            path.comm_lottery_3d = response.data.cmLT[0].three_d
            path.comm_lottery_4d = response.data.cmLT[0].four_d

            path.comm_tournament = response.data.cmTN[0].account_commission
          }
        })
        .catch(response => {
        });
    },
    getChildPositionTaking: function() {
      let account_id = this.search_id
      this.$store
        .dispatch("user/getChildPositionTaking", { account_id })
        .then(response => {
          this.loading = true
          let path = this.$refs.ptSettings.$refs
          if(response.data.ptSB.length > 0) {
            let data = response.data.ptSB
            path.ptTableRowLiveCasino.livecasino_upline_pt = response.data.ptLC[0].upline_pt
            path.ptTableRowLiveCasino.livecasino_account_pt = response.data.ptLC[0].account_pt
            path.ptTableRowLiveCasino.livecasino_upline_remaining = response.data.ptLC[0].upline_remaining
            path.ptTableRowLiveCasino.livecasino_account_min = response.data.ptLC[0].account_min
            path.ptTableRowSlots.slots_upline_pt = response.data.ptSL[0].upline_pt
            path.ptTableRowSlots.slots_account_pt = response.data.ptSL[0].account_pt
            path.ptTableRowSlots.slots_upline_remaining = response.data.ptSL[0].upline_remaining
            path.ptTableRowSlots.slots_account_min = response.data.ptSL[0].account_min

            path.ptTableRowSoccer.soccer_hdp_upline_pt = this.$helpers.getPTSB(data, 'HDP', 'SOCCER', 'upline_pt')
            path.ptTableRowSoccer.soccer_hdp_account_pt = this.$helpers.getPTSB(data, 'HDP', 'SOCCER', 'account_pt')
            path.ptTableRowSoccer.soccer_hdp_upline_remaining = this.$helpers.getPTSB(data, 'HDP', 'SOCCER', 'upline_remaining')
            path.ptTableRowSoccer.soccer_hdp_account_min = this.$helpers.getPTSB(data, 'HDP', 'SOCCER', 'account_min')
            path.ptTableRowSoccer.soccer_1x2_upline_pt = this.$helpers.getPTSB(data, '1X2', 'SOCCER', 'upline_pt')
            path.ptTableRowSoccer.soccer_1x2_account_pt = this.$helpers.getPTSB(data, '1X2', 'SOCCER', 'account_pt')
            path.ptTableRowSoccer.soccer_1x2_upline_remaining = this.$helpers.getPTSB(data, '1X2', 'SOCCER', 'upline_remaining')
            path.ptTableRowSoccer.soccer_1x2_account_min = this.$helpers.getPTSB(data, '1X2', 'SOCCER', 'account_min')
            path.ptTableRowSoccer.soccer_others_upline_pt = this.$helpers.getPTSB(data, 'OTHERS', 'SOCCER', 'upline_pt')
            path.ptTableRowSoccer.soccer_others_account_pt = this.$helpers.getPTSB(data, 'OTHERS', 'SOCCER', 'account_pt')
            path.ptTableRowSoccer.soccer_others_upline_remaining = this.$helpers.getPTSB(data, 'OTHERS', 'SOCCER', 'upline_remaining')
            path.ptTableRowSoccer.soccer_others_account_min = this.$helpers.getPTSB(data, 'OTHERS', 'SOCCER', 'account_min')

            path.ptTableRowParlay.parlay_upline_pt = this.$helpers.getPTSB(data, 'PARLAY', 'PARLAY', 'upline_pt')
            path.ptTableRowParlay.parlay_account_pt = this.$helpers.getPTSB(data, 'PARLAY', 'PARLAY', 'account_pt')
            path.ptTableRowParlay.parlay_upline_remaining = this.$helpers.getPTSB(data, 'PARLAY', 'PARLAY', 'upline_remaining')
            path.ptTableRowParlay.parlay_account_min = this.$helpers.getPTSB(data, 'PARLAY', 'PARLAY', 'account_min')

            if(['MMK','MMO'].includes(this.currency)) {
              path.ptTableRowSoccer.hdp_mmo_upline_pt = this.$helpers.getPTSB(data, 'HDPMMO', 'SOCCER', 'upline_pt')
              path.ptTableRowSoccer.hdp_mmo_account_pt = this.$helpers.getPTSB(data, 'HDPMMO', 'SOCCER', 'account_pt')
              path.ptTableRowSoccer.hdp_mmo_upline_remaining = this.$helpers.getPTSB(data, 'HDPMMO', 'SOCCER', 'upline_remaining')
              path.ptTableRowSoccer.hdp_mmo_account_min = this.$helpers.getPTSB(data, 'HDPMMO', 'SOCCER', 'account_min')

              path.ptTableRowParlay.parlay_mmo_upline_pt = this.$helpers.getPTSB(data, 'PARLAYMMO', 'PARLAYMMO', 'upline_pt')
              path.ptTableRowParlay.parlay_mmo_account_pt = this.$helpers.getPTSB(data, 'PARLAYMMO', 'PARLAYMMO', 'account_pt')
              path.ptTableRowParlay.parlay_mmo_upline_remaining = this.$helpers.getPTSB(data, 'PARLAYMMO', 'PARLAYMMO', 'upline_remaining')
              path.ptTableRowParlay.parlay_mmo_account_min = this.$helpers.getPTSB(data, 'PARLAYMMO', 'PARLAYMMO', 'account_min')
            }

            if (response.data.ptLO) {
              path.ptTableRowLotto.lotto_upline_pt = response.data.ptLO[0].upline_pt
              path.ptTableRowLotto.lotto_account_pt = response.data.ptLO[0].account_pt
              path.ptTableRowLotto.lotto_upline_remaining = response.data.ptLO[0].upline_remaining
              path.ptTableRowLotto.lotto_account_min = response.data.ptLO[0].account_min
            }

            if (response.data.ptKN) {
              path.ptTableRowKeno.keno_upline_pt = response.data.ptKN[0].upline_pt
              path.ptTableRowKeno.keno_account_pt = response.data.ptKN[0].account_pt
              path.ptTableRowKeno.keno_upline_remaining = response.data.ptKN[0].upline_remaining
              path.ptTableRowKeno.keno_account_min = response.data.ptKN[0].account_min
            }

            if (response.data.ptCF) {
              path.ptTableRowCockfight.cockfight_upline_pt = response.data.ptCF[0].upline_pt
              path.ptTableRowCockfight.cockfight_account_pt = response.data.ptCF[0].account_pt
              path.ptTableRowCockfight.cockfight_upline_remaining = response.data.ptCF[0].upline_remaining
              path.ptTableRowCockfight.cockfight_account_min = response.data.ptCF[0].account_min
            }

            if (response.data.ptLT) {
              path.ptTableRowLottery.lottery_1d_upline_pt = response.data.ptLT[0].upline_pt
              path.ptTableRowLottery.lottery_1d_account_pt = response.data.ptLT[0].account_pt
              path.ptTableRowLottery.lottery_1d_upline_remaining = response.data.ptLT[0].upline_remaining
              path.ptTableRowLottery.lottery_1d_account_min = response.data.ptLT[0].account_min

              path.ptTableRowLottery.lottery_2d_upline_pt = response.data.ptLT[1].upline_pt
              path.ptTableRowLottery.lottery_2d_account_pt = response.data.ptLT[1].account_pt
              path.ptTableRowLottery.lottery_2d_upline_remaining = response.data.ptLT[1].upline_remaining
              path.ptTableRowLottery.lottery_2d_account_min = response.data.ptLT[1].account_min
            }
            this.getUplinePositionTaking()
          }
        })
        .catch(response => {
          console.log("Failed:getChildPositionTaking", response)
        });
    },
    getUplinePositionTaking: function() {
      let account_id = this.uplineID
      this.$store
        .dispatch("user/getChildPositionTaking", { account_id })
        .then(response => {
          this.loading = true
          let path = this.$refs.ptSettings.$refs
          if(response.data.ptSB.length > 0) {
            let data = response.data.ptSB
            path.ptTableRowLiveCasino.livecasino_upline_max = response.data.ptLC[0].account_pt
            path.ptTableRowLiveCasino.livecasino_upline_min = response.data.ptLC[0].account_min
            path.ptTableRowSlots.slots_upline_max = response.data.ptSL[0].account_pt
            path.ptTableRowSlots.slots_upline_min = response.data.ptSL[0].account_min

            path.ptTableRowSoccer.soccer_hdp_upline_max = this.$helpers.getPTSB(data, 'HDP', 'SOCCER', 'account_pt')
            path.ptTableRowSoccer.soccer_hdp_upline_min = this.$helpers.getPTSB(data, 'HDP', 'SOCCER', 'account_min')
            path.ptTableRowSoccer.soccer_1x2_upline_max = this.$helpers.getPTSB(data, '1X2', 'SOCCER', 'account_pt')
            path.ptTableRowSoccer.soccer_1x2_upline_min = this.$helpers.getPTSB(data, '1X2', 'SOCCER', 'account_min')
            path.ptTableRowSoccer.soccer_others_upline_max = this.$helpers.getPTSB(data, 'OTHERS', 'SOCCER', 'account_pt')
            path.ptTableRowSoccer.soccer_others_upline_min = this.$helpers.getPTSB(data, 'OTHERS', 'SOCCER', 'account_min')
            path.ptTableRowParlay.parlay_upline_max = this.$helpers.getPTSB(data, 'PARLAY', 'PARLAY', 'account_pt')
            path.ptTableRowParlay.parlay_upline_min = this.$helpers.getPTSB(data, 'PARLAY', 'PARLAY', 'account_min')

            if(['MMK','MMO'].includes(this.currency)) {
              path.ptTableRowSoccer.hdp_mmo_upline_max = this.$helpers.getPTSB(data, 'HDPMMO', 'SOCCER', 'account_pt')
              path.ptTableRowSoccer.hdp_mmo_upline_min = this.$helpers.getPTSB(data, 'HDPMMO', 'SOCCER', 'account_min')

              path.ptTableRowParlay.parlay_mmo_upline_max = this.$helpers.getPTSB(data, 'PARLAYMMO', 'PARLAYMMO', 'account_pt')
              path.ptTableRowParlay.parlay_mmo_upline_min = this.$helpers.getPTSB(data, 'PARLAYMMO', 'PARLAYMMO', 'account_min')
            }

            if (response.data.ptLO) {
              path.ptTableRowLotto.lotto_upline_max = response.data.ptLO[0].account_pt
              path.ptTableRowLotto.lotto_upline_min = response.data.ptLO[0].account_min
            }

            if (response.data.ptKN) {
              path.ptTableRowKeno.keno_upline_max = response.data.ptKN[0].account_pt
              path.ptTableRowKeno.keno_upline_min = response.data.ptKN[0].account_min
            }

            if (response.data.ptCF) {
              path.ptTableRowCockfight.cockfight_upline_max = response.data.ptCF[0].account_pt
              path.ptTableRowCockfight.cockfight_upline_min = response.data.ptCF[0].account_min
            }

            if (response.data.ptLT) {
              path.ptTableRowLottery.lottery_1d_upline_max = response.data.ptLT[0].account_pt
              path.ptTableRowLottery.lottery_1d_upline_min = response.data.ptLT[0].account_min

              path.ptTableRowLottery.lottery_2d_upline_max = response.data.ptLT[1].account_pt
              path.ptTableRowLottery.lottery_2d_upline_min = response.data.ptLT[1].account_min
            }
          }
        })
        .catch(response => {
          console.log("Failed:getChildPositionTaking", response)
        });
    },
    getAccountDetails: function() {
      let account_id = this.search_id
      this.$store
        .dispatch("user/getAccountDetails", { account_id })
        .then(response => {
          this.isValid = true
          this.submission.success = response.success
          this.submission.status = response.errorTag

          this.account_id = this.search_id
          this.full_name = response.data.details[0].full_name
          this.contact_phone = response.data.details[0].contact_phone
          // this.contact_email = response.data.details[0].contact_email 
          this.uplineID = response.data.credit[0].parent_id
          this.selected_credit_limit = response.data.credit[0].credit_limit
          this.credit_limit = this.$helpers.numberFormat(response.data.credit[0].credit_limit)
          this.member_credit_limit = this.$helpers.numberFormat(response.data.credit[0].member_credit_limit)
          this.win_limit = (response.data.credit[0].win_limit) ? response.data.credit[0].win_limit / response.data.credit[0].credit_limit : this.win_limit
          this.daily_reset = (response.data.credit[0].daily_reset) ? 1 : 0
          this.accumulate_win = (response.data.credit[0].accumulate_win) ? response.data.credit[0].accumulate_win : this.accumulate_win
          if(this.search_id.length < 9) {
            if(response.data.schedule.length > 0) {
              for(let count = 1; count < 8; count ++) {
                let day = "schedule_" + count
                if(response.data.schedule[0][day] == true) {
                  this.payment_option.push(day)
                }
              }
            }
          }
          this.getChildPlatform()
          this.getChildCommission()
          this.getChildBetLimit()
          this.getChildPositionTaking()
        })
        .catch(response => {
          console.log("Failed:getAccountDetails", response)
          this.$router.push("/overview").catch(err=>{})
          this.isValid = false
          this.submission.success = response.success
          this.submission.status = this.$t("message." + response.errorTag)
        });
    }
  }
}
</script>